var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"co-novo-documento-signatario-icon-info"},[_c('v-tooltip',{attrs:{"bottom":"","max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"icon-info",attrs:{"size":_vm.tamanhoIcon}},on),[_vm._v(" mdi-information ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.descricaoCampo))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }